import initialState from '../store/initialState'
import testsTypes from '../constants/testsTypes'

export default function testsReducer(state = initialState.tests, action) {
  switch (action.type) {

    case testsTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case testsTypes.reset_test: {
      return {
        ...initialState.tests,
        items: state.items,
        test: state.test,
        totals: state.totals,
        pagination: state.pagination
      }
    }

    case testsTypes.clear_test: {
      return {
        ...initialState.tests,
        test: {
          questions: []
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // GET
    case testsTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case testsTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        test: action.payload,
        errors: []
      }
    }

    case testsTypes.pdf.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        errors: []
      }
    }

    case testsTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // INDEX
    case testsTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case testsTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.tests,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case testsTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.tests,
        errors: []
      }
    }

    case testsTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    case testsTypes.xlsx.request: {
      return {
        ...state,
        fetching_xlsx: true,
        errors: []
      }
    }

    case testsTypes.xlsx.success: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: []
      }
    }

    case testsTypes.xlsx.failure: {
      return {
        ...state,
        fetching_xlsx: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/testsReducer.js